import { RequiredError } from "../error/RequiredError.js";
import { countArray, getOptionalFirstItem } from "../util/array.js";
/** Provider with a fully synchronous interface */
export class Provider {
    requireItem(collection, id) {
        const item = this.getItem(collection, id);
        if (!item)
            throw new RequiredError(`Item must exist in "${collection}"`, id);
        return item;
    }
    countQuery(collection, query) {
        return countArray(this.getQuery(collection, query));
    }
    getFirst(collection, query) {
        return getOptionalFirstItem(this.getQuery(collection, { ...query, $limit: 1 }));
    }
    requireFirst(collection, query) {
        const first = this.getFirst(collection, query);
        if (!first)
            throw new RequiredError(`First item must exist in "${collection}"`, query);
        return first;
    }
}
/** Provider with a fully asynchronous interface */
export class AsyncProvider {
    async requireItem(collection, id) {
        const item = await this.getItem(collection, id);
        if (!item)
            throw new RequiredError(`Item must exist in "${collection}"`, id);
        return item;
    }
    async countQuery(collection, query) {
        return countArray(await this.getQuery(collection, query));
    }
    async getFirst(collection, query) {
        return getOptionalFirstItem(await this.getQuery(collection, { ...query, $limit: 1 }));
    }
    async requireFirst(collection, query) {
        const first = await this.getFirst(collection, query);
        if (!first)
            throw new RequiredError(`First item must exist in "${collection}"`, query);
        return first;
    }
}
